/**
 * Grenzen der Bildschirmgrößen (DESIGN `spacing.bp-tablet`, `spacing.bp-desktop`; wie `--breakpoint-*` in styles.css):
 * unter `BP_TABLET` Handy, ab `BP_DESKTOP` Desktop. Gemeinsam für App (`useScreen`) und Oberflächen-Tests.
 */
export const BP_TABLET = 768;
export const BP_DESKTOP = 1280;
/** Zwischenstufen (`phone-wide:` 640 px, `laptop:` 1024 px in styles.css), z. B. Vollbild-Arbeitsplatz ab `BP_LAPTOP`. */
export const BP_PHONE_WIDE = 640;
export const BP_LAPTOP = 1024;
